export default __webpack_public_path__ + "static/media/Yentra white 1.514893dd.png";